import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Desc from './Description.js';
import { EditableLabel } from './EditableLabel.js';
import { Select } from './Select.js';
import { SettingGroupGrid, ValueBox } from './SettingGroup.js';
import {
  HVAC_OPERATIONAL_MODE_NOT_SUPPORTED,
  hvacControlModeMapping,
  hvacOperationalModeMapping
} from '../Constants/constants.js';

export default function HvacWidget({
  id,
  index,
  indexPerZone,
  name,
  controlMode,
  controllerControlMode,
  operationalMode,
  controllerOperationalMode,
  supportedOperationalModes,
  disabled,
  onChange
}) {
  const { t } = useTranslation();
  const supportedModes = Number(supportedOperationalModes) || 0;
  const operationalModeSupported =
    operationalMode >= 0 && operationalMode <= 5 && (supportedModes & (1 << operationalMode)) !== 0;
  const displayedOperationalMode = operationalModeSupported
    ? operationalMode
    : HVAC_OPERATIONAL_MODE_NOT_SUPPORTED;
  const operationalModeDisabled = disabled || controlMode !== 0 || supportedModes === 0;
  const availableOperationalModes = Object.entries(hvacOperationalModeMapping).filter(([value]) =>
    Number(value) === HVAC_OPERATIONAL_MODE_NOT_SUPPORTED
      ? supportedModes === 0
      : (supportedModes & (1 << Number(value))) !== 0
  );

  const requestUpdate = (field, value) => {
    onChange(index, field, value);
  };

  return (
    <SettingGroupGrid label={`${t('hvac_cat')} ${indexPerZone + 1}`} fullWidth={true}>
      <Grid container>
        <Grid item xs={12}>
          <EditableLabel
            label={'my_memo'}
            id={id}
            value={name ?? -1}
            disabled={disabled}
            no_label={true}
            handleInput={(_, event, value) => requestUpdate('name', value === -1 ? '' : value)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <ValueBox id={`${id}.control_mode`}>
            <Typography gutterBottom>
              <Desc id="control_mode" />
            </Typography>
            <Select
              value={controlMode}
              controller_value={controllerControlMode}
              onChange={(event) => requestUpdate('control_mode', Number(event.target.value))}
              disabled={disabled}
            >
              {Object.entries(hvacControlModeMapping).map(([value, translationKey]) => (
                <MenuItem key={value} value={Number(value)}>
                  {t(translationKey)}
                </MenuItem>
              ))}
            </Select>
          </ValueBox>
        </Grid>
        <Grid item xs={12} md={6}>
          <ValueBox id={`${id}.operational_mode`}>
            <Typography gutterBottom>
              <Desc id="operational_mode" />
            </Typography>
            <Select
              value={displayedOperationalMode}
              controller_value={
                controllerOperationalMode >= 0 &&
                controllerOperationalMode <= 5 &&
                (supportedModes & (1 << controllerOperationalMode)) !== 0
                  ? controllerOperationalMode
                  : HVAC_OPERATIONAL_MODE_NOT_SUPPORTED
              }
              onChange={(event) => requestUpdate('operational_mode', Number(event.target.value))}
              disabled={operationalModeDisabled}
            >
              {availableOperationalModes.map(([value, translationKey]) => (
                <MenuItem key={value} value={Number(value)}>
                  {t(translationKey)}
                </MenuItem>
              ))}
            </Select>
          </ValueBox>
        </Grid>
      </Grid>
    </SettingGroupGrid>
  );
}
